import { render, staticRenderFns } from "./SaleInvoice.vue?vue&type=template&id=20e6faf8&scoped=true"
import script from "./SaleInvoice.vue?vue&type=script&lang=js"
export * from "./SaleInvoice.vue?vue&type=script&lang=js"
import style0 from "./SaleInvoice.vue?vue&type=style&index=0&id=20e6faf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e6faf8",
  null
  
)

export default component.exports